<ng-container *ngIf="addressesConfig$ | async as addressesConfig">
    <div class="form-holder {{ documentDirection }}">
        <serviceos-ng-local-loader
            [showLoader]="showLoader"
        ></serviceos-ng-local-loader>
        <div class="form-header">
            <span class="form-title">{{ addressesConfig.title }}</span>
        </div>
        <div
            class="form-content"
            [ngClass]="{ 'form-visible': userAddressFormExpanded }"
        >
            <serviceos-ng-alert
                class="error-alert"
                *ngIf="formErrorMessage"
                [type]="'error'"
            >
                {{ formErrorMessage }}
            </serviceos-ng-alert>
            <ul
                class="list"
                *ngIf="(addresses | async)?.length; else noAddressesItem"
            >
                <li
                    *ngFor="let address of addresses | async"
                    class="item"
                    [ngClass]="{ selected: address.default }"
                >
                    <div class="left-column">
                        <serviceos-ng-system-icon
                            [icon]="'pinned-deafult-choosed'"
                            (click)="setAsDefault(address)"
                        ></serviceos-ng-system-icon>
                        <span class="formatted-address" *ngIf="!address.address_formatted">{{
                            formatAddress(address)
                        }}</span>
                        <span class="formatted-address" *ngIf="address.address_formatted">{{
                            address.address_formatted
                        }}</span>
                    </div>
                    <div class="right-column">
                        <serviceos-ng-link
                            [type]="'secondary'"
                            [size]="'small'"
                            (click)="deleteAddress(address.id)"
                        >
                            <span class="delete">{{ addressesConfig.delete_button_title }}</span>
                        </serviceos-ng-link>
                    </div>
                </li>
            </ul>
            <span class="form-label-title">{{
                addressesConfig.add_form.title
            }}</span>
            <form
                [formGroup]="userAddressForm"
                (ngSubmit)="formSubmit()"
                id="user-address-form"
            >
                <div class="row">
                    <div class="col-12" *ngIf="addressForm$ | async as addressForm; else defaultAddressLineTwo">
                        <ng-container *ngIf="addressForm?.address_line_two?.enable !== false">
                            <serviceos-ng-form-field>
                                <serviceos-ng-label>{{
                                    addressesConfig.add_form
                                        .address_line_two_input_label
                                }}</serviceos-ng-label>
                                <input
                                    [serviceosNgInput]="addressLineTwo?.value"
                                    [error]="
                                        addressLineTwo?.invalid &&
                                        (addressLineTwo?.dirty ||
                                            addressLineTwo?.touched)
                                    "
                                    type="text"
                                    id="addressLineTwo"
                                    name="addressLineTwo"
                                    formControlName="addressLineTwo"
                                />
                                <serviceos-ng-error-message>{{
                                    addressesConfig.add_form
                                        .address_line_two_input_error
                                }}</serviceos-ng-error-message>
                            </serviceos-ng-form-field>
                        </ng-container>
                    </div>
                    <ng-template #defaultAddressLineTwo>
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>{{
                                addressesConfig.add_form
                                    .address_line_two_input_label
                            }}</serviceos-ng-label>
                            <input
                                [serviceosNgInput]="addressLineTwo?.value"
                                [error]="
                                    addressLineTwo?.invalid &&
                                    (addressLineTwo?.dirty ||
                                        addressLineTwo?.touched)
                                "
                                type="text"
                                id="addressLineTwo"
                                name="addressLineTwo"
                                formControlName="addressLineTwo"
                            />
                            <serviceos-ng-error-message>{{
                                addressesConfig.add_form
                                    .address_line_two_input_error
                            }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </ng-template>
                    <div class="col-6">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>{{
                                addressesConfig.add_form
                                    .address_line_one_input_label
                            }}</serviceos-ng-label>
                            <input
                                [serviceosNgInput]="addressLineOne?.value"
                                [error]="
                                    addressLineOne?.invalid &&
                                    (addressLineOne?.dirty ||
                                        addressLineOne?.touched)
                                "
                                type="text"
                                id="addressLineOne"
                                name="addressLineOne"
                                formControlName="addressLineOne"
                            />
                            <serviceos-ng-error-message>{{
                                addressesConfig.add_form
                                    .address_line_one_input_error
                            }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                    <div class="col-6">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>{{
                                addressesConfig.add_form.postcode_label
                            }}</serviceos-ng-label>
                            <input
                                [serviceosNgInput]="postcode?.value"
                                [error]="
                                    postcode?.invalid &&
                                    (postcode?.dirty || postcode?.touched)
                                "
                                type="text"
                                id="postcode"
                                name="postcode"
                                formControlName="postcode"
                            />
                            <serviceos-ng-error-message>{{
                                addressesConfig.add_form.postcode_error
                            }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                    <div class="col-12" *ngIf="addressForm$ | async as addressForm">
                        <ng-container *ngIf="addressForm?.city?.enable">
                            <serviceos-ng-form-field>
                                <serviceos-ng-label>{{
                                    addressesConfig.add_form
                                    .city_input_label ? addressesConfig.add_form
                                    .city_input_label : 'City'
                                }}</serviceos-ng-label>
                                <input
                                [serviceosNgInput]="city?.value"
                                [error]="
                                city?.invalid &&
                                (city?.dirty ||
                                city?.touched)
                                "
                                type="text"
                                id="city"
                                name="city"
                                formControlName="city"
                                />
                                <serviceos-ng-error-message>{{
                                    addressesConfig.add_form
                                    .city_input_error ? addressesConfig.add_form
                                    .city_input_error : 'Please enter a city.'
                                }}</serviceos-ng-error-message>
                            </serviceos-ng-form-field>
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="submit">
                            {{ addressesConfig.add_form.confirm_button_title }}
                        </button>
                    </div>
                </div>
            </form>
            <div
                class="add-address-btn-holder row"
                *ngIf="!userAddressFormExpanded"
            >
                <div class="col-12">
                    <serviceos-ng-system-icon
                        [icon]="'plus'"
                    ></serviceos-ng-system-icon>
                    <serviceos-ng-link
                        [type]="'primary'"
                        [size]="'small'"
                        [font_weight]="'semi-bold'"
                        (click)="
                            userAddressFormExpanded = !userAddressFormExpanded
                        "
                    >
                        {{ addressesConfig.add_button_title }}
                    </serviceos-ng-link>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noAddressesItem>
        <span class="no-addresses-item">{{
            addressesConfig.empty_message
        }}</span>
    </ng-template>
</ng-container>
